import { DrillDownMenuItem } from "@/components/root/drilldown-menu/drilldown-menu.state";
import { PlaybookDataDescriptor } from "../data/model";

const download_item: DrillDownMenuItem = {
  disable: false,
  isCategory: false,
  isPremium: false,
  name: "Download Data",
  icon: "CSV",
  subItems: [],
  action: "download",
};

const cancel_running: DrillDownMenuItem = {
  disable: false,
  isCategory: false,
  isPremium: false,
  name: "Cancel Running",
  icon: "Trash",
  subItems: [],
  action: "cancel_running",
};

const cancel_data_collecting: DrillDownMenuItem = {
  disable: false,
  isCategory: false,
  isPremium: false,
  name: "Cancel data collecting",
  icon: "Trash",
  subItems: [],
  action: "cancel_data_collecting",
};

export const get_menu_items_for_instance = (
  instance: PlaybookDataDescriptor
): DrillDownMenuItem[] => {
  switch (instance.status) {
    case "Ready":
      return [
        // download_item,
        {
          disable: false,
          isCategory: false,
          isPremium: false,
          name: "Generate script",
          icon: "Code",
          subItems: [],
          action: "run",
        },
      ];
    case "Running":
      return [/* download_item, */ cancel_running];
    case "Building":
      return [cancel_data_collecting];
    case "Finished":
    case "Stopped":
      return [
        //  download_item,
        {
          disable: false,
          isCategory: false,
          isPremium: false,
          name: "View Results",
          icon: "Detection",
          subItems: [],
          action: "view_results",
        },
      ];
    default:
      return [];
  }
};
